import React from 'react';
import Page from '../../components/Page';
import { FileText } from 'lucide-react';

const NFesOverviewPage: React.FC = () => {
  return (
    <Page
      title="📄 NFes - Visão Geral"
      subtitle="Dashboard principal das Notas Fiscais Eletrônicas"
      onRefresh={() => window.location.reload()}
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <FileText 
            className="h-16 w-16 mx-auto mb-4" 
            style={{ color: 'var(--primary)' }}
          />
          <h2 
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            NFes - Em Desenvolvimento
          </h2>
          <p 
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  );
};

export default NFesOverviewPage;
